<template>
    <div>
        <h6 class="heading-small text-muted mb-4">Edit Schedule</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <base-input alternative="" label="Schedule of Jobs (seconds)" placeholder="" v-model="inputSched" input-classes="form-control" required />

            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                <button type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            component_x = this
            if (component_x.profileId > 0){
                var setting_data = await HTTPRequest.getRequest(component_x.endPoint + 'settings/' + component_x.profileId, null)
                if(setting_data == undefined){
                    component_x.$router.go()
                } else {
                    if(setting_data["error"] == undefined){
                        component_x.inputSched = setting_data["value"];
                    } else {
                        this.errors = setting_data["error"].split(",");
                    } 
                }
            } 
        },
        data: function () {
            return {
                inputSched: '',
                errors: []
            }
        },
        methods: {
            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Schedule', this.inputSched));
                this.errors.push(ValidateField.wholeNumberFormat('Schedule', this.inputSched));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            update: async function () {
                if(!this.validateForm()) {
                    var settingPayload = {
                        setting: {
                            value: this.inputSched
                        }
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'settings/' + this.profileId, null, settingPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>